import { designerOrigin } from '../reporting/reportDesignerUrl';

/** Which page of the embedded DevExpress Web Dashboard is shown (ADR-0016). */
export type DashboardFrameMode = 'design' | 'view';

/**
 * Builds the iframe URL for a mode / dashboard / designer session:
 *   design → {origin}/reports/dashboard/designer?id={oid}&rds={token}
 *   view   → {origin}/reports/dashboard/viewer?id={oid}&rds={token}
 * A missing id opens the designer's own "New dashboard" flow.  `rds` is the
 * DASHBOARD-scoped designer-session token — sent once; the API forwarder
 * continues from a cookie.  Same origin as the report designer (one host).
 */
export function dashboardFrameSrc(mode: DashboardFrameMode, dashboardId: string | null, token: string): string {
  const q = new URLSearchParams();
  if (dashboardId) q.set('id', dashboardId);
  q.set('rds', token);
  return `${designerOrigin()}/reports/dashboard/${mode === 'view' ? 'viewer' : 'designer'}?${q.toString()}`;
}
